import { IInference, IAstNode } from './typings';
import * as Functions from '../functions';
import { InferenceError } from '../errors';
import { DateFunctionMap } from '../functions/configs/date';
import { IFunctionToken } from '../typings/token';



// 计算函数的返回值类型
export function inferenceFunctionCallNode(inference: IInference, astNode: IAstNode) {
  const inferencedArgs = (astNode.args as IAstNode[]).map(arg => {
    return { ...arg, ...inference(arg) };
  });


  const token = astNode.token as IFunctionToken;
  const functionCode = astNode.value!.toUpperCase() as keyof typeof Functions;


  // 除了Now之外的函数都需要至少一个参数
  if (!['NOW', 'EVENT_OCCURRENCE_DATETIME'].includes(functionCode) && !inferencedArgs.length) {
    throw new InferenceError('function-argument-lost', `函数 ${token.formatName} 参数不能为空`, token.position);
  }

  // if ([
  //   'AND', 'AVG', 'COUNT', 'DURATION_DIFF',
  //   'FILTER', 'JOINER', 'LENGTH', 'MAX', 'MIN', 'MOD',
  //   'OCCURRENCE_TIMES', 'OR', 'SUBSTR_AFTER', 'SUBSTR_LAST', 'SUBSTR', 'SUM',
  //   'NEGATIVE', 'NOW', 'IF_ELSE', 'DS_FIND', 'ALIGNED_WEEK_OF_MONTH', 'ELEMENT_MATCH',
  //   'EVENT_OCCURRENCE_DATETIME'
  // ].includes(functionCode)) {
  //   return (Functions[functionCode] as any)(inferencedArgs, token);
  // }


  if (Object.keys(DateFunctionMap).includes(functionCode)) {
    const dateFunctionConfig = DateFunctionMap[functionCode as keyof typeof DateFunctionMap];
    const func = dateFunctionConfig.function;
    const argumentTypes = dateFunctionConfig.argumentTypes;
    return func(inferencedArgs, token, argumentTypes);
  }

  if (Object.prototype.hasOwnProperty.call(Functions, functionCode)) {
    return (Functions[functionCode] as any)(inferencedArgs, token);
  }

  throw new InferenceError('invalid-function', `无效的函数 \`${astNode.value}\``, token.position);
}
